module.exports = __webpack_public_path__ + "img/perfil_cifotico-lordotico.4953afca.jpg";